import React from 'react'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs'
import { useTabQuery } from 'hooks/useQueryState'
import ClearTestApiCacheTab from './ClearTestApiCacheTab'
import SyncNekuRedisKeyTab from './SyncNekuRedisKeyTab'
import UploadStoryAudioTab from './UploadStoryAudioTab'

export default function DevTools() {
  const [tab, setTab] = useTabQuery('devToolsTab', 'api-cache')

  return (
    <div className="flex-1 space-y-4">
      <div className="flex items-center justify-between space-y-2">
        <h2 className="text-3xl font-bold tracking-tight">Dev tools</h2>
      </div>

      <Tabs value={tab} onValueChange={setTab} className="space-y-4">
        <TabsList>
          <TabsTrigger value="api-cache">
            Clear test environment API cache
          </TabsTrigger>
          <TabsTrigger value="neku-redis-sync">
            Sync prod Redis key to test
          </TabsTrigger>
          <TabsTrigger value="upload-story-audio">
            Upload story assets to GCS
          </TabsTrigger>
        </TabsList>
        <TabsContent value="api-cache" className="space-y-4">
          <ClearTestApiCacheTab />
        </TabsContent>
        <TabsContent value="neku-redis-sync" className="space-y-4">
          <SyncNekuRedisKeyTab />
        </TabsContent>
        <TabsContent value="upload-story-audio" className="space-y-4">
          <UploadStoryAudioTab />
        </TabsContent>
      </Tabs>
    </div>
  )
}
